import React, { useEffect } from 'react';
import { authService } from '@/services/authService';
import { getMemoryAccessToken, clearMemoryAccessToken } from '@/lib/authToken';
import { useAuthStore } from '@/store/authStore';

const AuthBootstrap: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { login, logout, setAuthHydrated } = useAuthStore();

  useEffect(() => {
    let cancelled = false;

    const hydrate = async () => {
      if (useAuthStore.getState().isAuthenticated) {
        setAuthHydrated(true);
        return;
      }

      try {
        const session = await authService.getSession();
        if (cancelled) return;
        login({
          _id: session._id,
          name: session.name,
          email: session.email,
          phone: session.phone ?? '',
          role: session.role,
          subRole: session.subRole,
          addresses: session.addresses ?? [],
          location: session.location,
          address: session.address ?? session.location?.address ?? '',
        });
      } catch {
        if (cancelled) return;
        clearMemoryAccessToken();
        logout();
      } finally {
        if (!cancelled) {
          setAuthHydrated(true);
        }
      }
    };

    void hydrate();

    return () => {
      cancelled = true;
    };
  }, [login, logout, setAuthHydrated]);

  return <>{children}</>;
};

export default AuthBootstrap;
